import { Grid } from "@mui/material";
import React from "react";

export default function StampWrap(props) {
  const detailData = props.detailData;
  const giftList = props.detailData.stampGifts;

  const atdcYn = props.atdcYn;

  const stampRender = (item) => {
    let render = []; //return
    let dailyMaxCount = item.accCount; //스탬프 최대 갯수
    let gIndex = 0; //giftList index
    let tmCnt = Number(item.totalMaxCount);
    let addCnt = tmCnt == 17 || tmCnt == 27 ? 2 : 0;
    //17, 27개일 경우 2개 더 추가해주기 위한 cnt
    let date = 0;
    let stampCnt = 0;

    for (let i = 1; i <= tmCnt + addCnt; i++) {
      if (tmCnt == 17 || tmCnt == 27) {
        if (i == 1 || i == 5) {
          render.push(<Grid item />);
          date--;
          continue;
        } else {
          stampCnt++;

          render.push(
            <Grid item className={dailyMaxCount > 0 ? "on" : ""}>
              <div
                className="stamp"
                style={{
                  backgroundImage:
                    dailyMaxCount > 0
                      ? `${"url(" + detailData.actvImgUrl + ")"}`
                      : `${"url(" + detailData.dsblImgUrl + ")"}`,
                }}
              />
              {dailyMaxCount <= 0 && atdcYn == "Y" && (
                <span className="date-num">
                  <p>{date + 1}</p>일차
                </span>
              )}
              {stampCnt == giftList[gIndex].stamp ? (
                <span
                  className="benefit"
                  style={{
                    border:
                      dailyMaxCount > 0 ? `1px solid ${detailData.clr}` : "",
                    color: dailyMaxCount > 0 ? `${detailData.clr}` : "",
                  }}
                >
                  {giftList[gIndex].giftFlag == "1"
                    ? giftList[gIndex].dcFlag == "1"
                      ? giftList[gIndex].couponAmount + "원"
                      : giftList[gIndex].couponAmount + "%"
                    : giftList[gIndex].giftProduct + "P"}
                </span>
              ) : (
                ""
              )}
            </Grid>
          );
          date++;
        }
      } else {
        stampCnt++;
        render.push(
          <Grid item className={dailyMaxCount > 0 ? "on" : ""}>
            <div
              className="stamp"
              style={{
                backgroundImage:
                  dailyMaxCount > 0
                    ? `${"url(" + detailData.actvImgUrl + ")"}`
                    : `${"url(" + detailData.dsblImgUrl + ")"}`,
              }}
            />
            {dailyMaxCount <= 0 && atdcYn == "Y" && (
              <span className="date-num">
                <p>{date + 1}</p>일차
              </span>
            )}
            {stampCnt == giftList[gIndex].stamp ? (
              <span
                className="benefit"
                style={{
                  border:
                    dailyMaxCount > 0 ? `1px solid ${detailData.clr}` : "",
                  color: dailyMaxCount > 0 ? `${detailData.clr}` : "",
                }}
              >
                {giftList[gIndex].giftFlag == "1"
                  ? giftList[gIndex].dcFlag == "1"
                    ? giftList[gIndex].couponAmount + "원"
                    : giftList[gIndex].couponAmount + "%"
                  : giftList[gIndex].giftProduct + "P"}
              </span>
            ) : (
              ""
            )}
          </Grid>
        );
        date++;
      }

      if (stampCnt == giftList[gIndex].stamp && gIndex < giftList.length - 1)
        gIndex++;
      dailyMaxCount--;
    }

    return render;
  };

  return (
    <Grid container spacing={1} className="stamp-grid" justifyContent="center">
      {stampRender(detailData)}
    </Grid>
  );
}
